export const people = (state) => state.people;
export const invites = (state) => state.invites;

export const team = (state) => {
  return state.people.concat(state.invites);
};
